import styled from '@emotion/styled';
import { gridSize } from '@atlaskit/theme';

const ButtonContainer = styled.div`
  width: 100%;
  padding-top: ${gridSize() * 2}px;
`;

export default ButtonContainer;
